export enum CronType {
	UNIX = 'UNIX',
	QUARTZ = 'QUARTZ'
}